// extracted by mini-css-extract-plugin
export var childrenContainer = "_b2-0";